import styled from "styled-components";
import { Banner } from "@similarweb/ui-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledBanner = styled(Banner)`
    margin-bottom: 45px;
    background-color: ${colorsPalettes.sky[100]};

    & > div > div > div {
        background-size: 60px 60px;
    }
`;
